import React from 'react'
import Text from '@component/Text/Text'

interface IProps {
    className?: string
}

const PayToSeeTag = ({className}: IProps) => {
    return (
        <div
            className={`inline-flex px-[7px] py-[2px] rounded-full bg-primary_tint01 dark:bg-dark_primary_tint01 ${className}`}>
            <Text className={'text-primary_shade dark:text-dark_primary_shade text-body_comm font-bold'}>
                Pay to see
            </Text>
        </div>
    )
}
export default PayToSeeTag
